document.addEventListener('DOMContentLoaded', function() {
    // Open Account Popup when click on 'Account'  
    const cKOpenAccountBtn = document.getElementById("ck-open-account");
    const ckAccountPopup = document.getElementById("ck-open-account-popup");
  
    if (cKOpenAccountBtn) {
      cKOpenAccountBtn.addEventListener("click", function () {
          if (ckAccountPopup.style.display === "flex") {
              ckAccountPopup.style.display = "none";
          } else {
              ckAccountPopup.style.display = "flex";
          }
      });
    }
  
  // [CK] Add subscription steps to Recharge page
    if (window.location.href.includes("get-subscription-access")) {
      const ckMainElement = document.querySelector('#main');
      
      // Erstelle das Div-Element für technische Hinweise
      const ckInfoBox = document.createElement('div');
      ckInfoBox.className = 'ck-recharge-info';
      
      const ckInfoBoxH2 = document.createElement('h2');
      ckInfoBoxH2.textContent = 'Hilfe bei technischen Problemen:';
      ckInfoBox.appendChild(ckInfoBoxH2);
      
      const ckInfoBoxP = document.createElement('p');
      ckInfoBoxP.innerHTML = `<strong>&#9432; Hinweis: </strong>Sollte bei Ihnen gerade ein Problem beim Zugriff auf Ihr Sparplan Konto auftreten, wenden Sie sich mit Ihrem Anliegen bitte direkt an uns per E-Mail unter: support@healthroutine.de<br><br>
        <strong>Gerne passen wir Ihren Sparplan für Sie an</strong>.`;
      ckInfoBox.appendChild(ckInfoBoxP);
      
      // Füge das Div-Element für technische Hinweise am Ende des Body-Elements hinzu
      
      // Erstelle das Div-Element für Anmelde-Schritte
      const ckStepsDiv = document.createElement('div');
      ckStepsDiv.className = 'ck-login-steps';
      
      const ckStepsHeading = document.createElement('h2');
      ckStepsHeading.textContent = 'So können Sie sich anmelden:';
      
      const ckStepsList = [
          "Tragen Sie oben in das Feld bitte Ihre E-Mail-Adresse ein.",
          "Klicken Sie bitte auf 'Login Code per E-Mail versenden'",
          "Lassen Sie diese Seite bitte geöffnet. Hier können Sie gleich den Code von der zugesendeten E-Mail eintragen.",
          "Der Code wird Ihnen innerhalb von 2-3 Minuten per E-Mail zugesendet.",
          "Öffnen Sie bitte Ihr E-Mail Postfach und öffnen Sie die Mail mit Ihrem persönlichen Code.",
          "Fügen Sie diesen Code anschließend bitte hier in das vorgesehene Feld ein.",
          "Sie werden dann eingeloggt und können Ihre Sparpläne individuell anpassen und verwalten."
      ];
      
      const ckListElement = document.createElement('ol');
      ckStepsList.forEach(step => {
          const ckListItem = document.createElement('li');
          ckListItem.textContent = step;
          ckListElement.appendChild(ckListItem);
      });
      
      ckStepsDiv.appendChild(ckStepsHeading);
      ckStepsDiv.appendChild(ckListElement);

      
      // Füge das Div-Element für Anmelde-Schritte nach der Info-Box hinzu
      ckMainElement.appendChild(ckInfoBox);
      ckMainElement.appendChild(ckStepsDiv);
      
    };
  
  // [CK] Add subscription steps to Klavyio verification page
    if (window.location.href.includes("DE-StartedSubscription-Transactional")) {
        const ckStepsDiv = document.createElement('div');
        ckStepsDiv.className = 'ck-login-steps';
        ckStepsDiv.setAttribute("style","margin-bottom: 60px !important");
  
        const ckStepsHeading = document.createElement('h2');
        ckStepsHeading.textContent = 'So können Sie sich anmelden:';
  
        const ckStepsList = [
          "Tragen Sie oben in das Feld bitte Ihre E-Mail-Adresse ein.",
          "Klicken Sie bitte auf 'Verifizierungscode zusenden'",
          "Lassen Sie diese Seite bitte geöffnet. Hier können Sie gleich den Code von der zugesendeten E-Mail eintragen.",
          "Der Code wird Ihnen innerhalb von 2-3 Minuten per E-Mail zugesendet.",
          "Öffnen Sie bitte Ihr E-Mail Postfach und öffnen Sie die Mail mit Ihrem persönlichen Code.",
          "Fügen Sie diesen Code anschließend bitte hier in das vorgesehene Feld ein.",
          "Sie werden dann eingeloggt und können Ihre Sparpläne individuell anpassen und verwalten."
        ];
  
        const ckListElement = document.createElement('ol');
  
        ckStepsList.forEach(step => {
            const ckListItem = document.createElement('li');
            ckListItem.textContent = step;
            ckListElement.appendChild(ckListItem);
        });
  
        ckStepsDiv.appendChild(ckStepsHeading);
        ckStepsDiv.appendChild(ckListElement);
  
        const mainElement = document.querySelector('#main');
        mainElement.prepend(ckStepsDiv);
    };
});  
